import { JSX } from "react";
import { registerAnalyticswithAppID } from "analyticssystems";
import { GlobalProviders } from "./providers/GlobalProviders";
import { Routes, Route, useLocation } from 'react-router';
import { AnimatePresence } from 'framer-motion';
import { HomePage } from "./pages/common/home";
import { NamaHalaman } from "./pages/test";
import { CoursePage1 } from "./pages/common/course/coursepage1";
import { CoursePage2 } from "./pages/common/course/coursepage2";
import { CoursePage3 } from "./pages/common/course/coursepage3";
import { MaterialText } from "./pages/common/course/coursepage1/materialtext";
import { MaterialQuiz } from "./pages/common/course/coursepage1/materialquiz";
import { MaterialVideo1 } from "./pages/common/course/coursepage1/materialvideo1";
import { MaterialVideo2 } from "./pages/common/course/coursepage1/materialvideo2";
import { QuizPage } from "./pages/common/course/coursepage1/materialquiz/quizpage";
import { ForumPage } from "./pages/common/forum/forumpage";
import { ProfilePage } from "./pages/common/user/profile";
import { DialogHost } from "./providers/DialogHost";
import { Login } from "./pages/common/user/login";
import Course from "./pages/common/course/courseinfo";
import { Certificate } from "./pages/Certificate";
registerAnalyticswithAppID("elearningntt");

export const App = (): JSX.Element => {
  const location = useLocation();
  return (
    <GlobalProviders>
      <DialogHost>
        <AnimatePresence mode="popLayout">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<HomePage />} />
            <Route path="/test" element={<NamaHalaman />} />
            <Route path="/courseintro" element={<Course />} />
            <Route path="/course1" element={<CoursePage1 />} />
            <Route path="/course1/materialtext" element={<MaterialText />} />
            <Route path="/course1/materialquiz" element={<MaterialQuiz />} />
            <Route path="/course1/materialquiz/quizsample" element={<QuizPage />} />
            <Route path="/course1/materialvideo1" element={<MaterialVideo1 />} />
            <Route path="/course1/materialvideo2" element={<MaterialVideo2 />} />
            <Route path="/course2" element={<CoursePage2 />} />
            <Route path="/course3" element={<CoursePage3 />} />
            <Route path="/forum" element={<ForumPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/certificate" element={<Certificate />} />

          </Routes>
        </AnimatePresence></DialogHost>
    </GlobalProviders>
  );
};